import _ from 'lodash'

export function toNumber(val: string) {
  if (!val) return null
  if (_.isNumber(val)) return val
  return _.toNumber(val.toString().replace(/,/g, '')) || null
}